var React = require('react');

function MvMultiplier (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Capa 2"},React.createElement("path",{"d":"M5.46 4.48l-.98.98-1.75-1.75L.98 5.46 0 4.48l1.75-1.75L0 .98.98 0l1.75 1.75L4.48 0l.98.98-1.75 1.75 1.75 1.75z","data-name":"Capa 1","fill":"#fff"})));
}

MvMultiplier.defaultProps = {"viewBox":"0 0 5.46 5.46"};

module.exports = MvMultiplier;

MvMultiplier.default = MvMultiplier;
